import { Button, Group, Modal, Textarea, TextInput } from '@mantine/core';
import { isNotEmpty, useForm } from '@mantine/form';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ForcedResult } from '../../data-access/types/types';
import ValidationStatusSwitch from '../validation-status-switch/validation-status-switch';

import classnames from './force-result-modal.module.css';

import { FORM_STATUS, formatDate } from '@data-access';
import { StatusCell } from '@ui';

export interface ForceResultModalProps {
  forcedResult?: ForcedResult;
  defaultValidationStatus: FORM_STATUS;
  opened: boolean;
  close: () => void;
  onSubmit: (values: { status: FORM_STATUS; comment: string }) => void;
}

export function ForceResultModal(props: ForceResultModalProps) {
  const { forcedResult, opened, close, defaultValidationStatus } = props;
  const { t } = useTranslation();
  console.log('forcedResult', forcedResult);
  const form = useForm({
    initialValues: {
      status: false,
      comment: forcedResult?.comment || '',
    },
    transformValues(values) {
      return {
        ...values,
        // if status is true, set status to REJECTED, otherwise set to FINISHED
        status: values.status ? FORM_STATUS.REJECTED : FORM_STATUS.FINISHED,
      };
    },
    validate: {
      comment: isNotEmpty(t('forms.validation.notEmpty')),
    },
  });
  const title = forcedResult
    ? `${t('results.forcedAt')} ${formatDate({
        date: forcedResult.date,
        format: 'display',
      })}`
    : t('results.forceResult');

  useEffect(() => {
    // on forcedResult change, update form values
    if (forcedResult) {
      form.setValues({
        status: forcedResult.estimated_status === FORM_STATUS.REJECTED,
        comment: forcedResult.comment,
      });
    } else {
      form.setValues({
        status: false,
        comment: '',
      });
    }
  }, [forcedResult]);

  console.log('defaultValidationStatus', defaultValidationStatus);
  return (
    <Modal
      classNames={{
        title: classnames.title,
      }}
      onClose={close}
      opened={opened}
      size="lg"
      title={title}
    >
      <form onSubmit={form.onSubmit((values) => props.onSubmit(values))}>
        <Group justify="space-between">
          <Group mr="sm">
            <span>{t('results.estimatedStatus')}</span>
            <StatusCell status={defaultValidationStatus} />
          </Group>
          <Group ml="sm">
            {forcedResult ? (
              <>
                <span>{t('results.forcedStatus')}</span>
                <StatusCell status={forcedResult.forced_status} />
              </>
            ) : (
              <ValidationStatusSwitch
                {...form.getInputProps('status', { type: 'checkbox' })}
              />
            )}
          </Group>
        </Group>

        {forcedResult ? (
          <TextInput mt="sm" readOnly value={forcedResult.author} />
        ) : null}

        <Textarea
          mt="sm"
          placeholder={t('results.commentPlaceholder')}
          readOnly={!!forcedResult}
          {...form.getInputProps('comment')}
        />

        <Group justify="space-between" mt="sm">
          <Button color="red" onClick={close} type="button">
            {t('common.back')}
          </Button>
          {!forcedResult ? (
            <Button type="submit">{t('common.add')}</Button>
          ) : null}
        </Group>
      </form>
    </Modal>
  );
}

export default ForceResultModal;
